import { lazy } from 'react'

export const InterestInPeopleVariant1 = lazy(
  () => import('./InterestInPeopleVariant1'),
)
